import { MultiFieldDynamicFields } from '../multiFieldDynamicFields';
import { FormikProps } from 'formik';
import { MultiDynamicField } from '../../../../../shared/types/assistant';

export const IdentityAndRole = ({
    formikIdentityAndRole,
}: {
    formikIdentityAndRole: FormikProps<{ [key: string]: MultiDynamicField[] }>;
}) => {
    return (
        <MultiFieldDynamicFields
            formik={formikIdentityAndRole}
            name="identityAndRole"
            label="Identidad y Rol"
            description="Define la identidad y el rol de tu asistente virtual, incluyendo Nombre, Rol, Postura y Modelo Conversacional. Esto permite comprender cómo interactúa con los usuarios y qué tipo de información proporciona."
            example={{
                title: 'Nombre',
                description: 'Nova.',
            }}
        />
    );
};
